import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { BasePagingResponse } from "../_types";
import { QueryKeys } from "../queryKeys";


async function getMemberVposBankList(): Promise<BasePagingResponse<any>> {
  try {

    let dataFromApi = await axiosInstance.get("/MemberVPos/Banks", {});
    return dataFromApi.data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetMemberVposBankList() {
  return useQuery<any | undefined, Error>(
    [QueryKeys.GetMemberVposBankList],
    () => getMemberVposBankList());
}